module.exports = __webpack_public_path__ + "img/home.4687210f.png";